import { Injectable } from '@angular/core';
import { UtilityService } from 'app/core/utility/services/utility.service';
import { ComplexPropertyConfiguration } from 'app/reporting/analytics-core/interfaces/widget.interface';
import * as moment_ from 'moment';
import * as numeral_ from 'numeral';
import { DatatableColumnConfig } from '../interfaces/datatable.interface';

const numeral = numeral_;
const moment = moment_;

@Injectable()
export class DatatableConfigurationMapperService {
	generateColumnConfigurationForDataTable(datatableColumnConfig: any): DatatableColumnConfig[] {
		const datatableColumnConfiguration: DatatableColumnConfig[] = [];
		for (const colConfig of datatableColumnConfig) {
			const colObj: DatatableColumnConfig = {} as DatatableColumnConfig;
			colObj.name = colConfig.columnName;
			colObj.prop = colConfig.columnKey;
			colObj.columnFormat = colConfig.columnFormat;
			colObj.columnType = colConfig.columnType;
			colObj.columnPrepend = colConfig.columnPrepend ? colConfig.columnPrepend : '';
			colObj.columnSuffix = colConfig.columnSuffix ? colConfig.columnSuffix : '';
			colObj.headerClass = colConfig.columnHeaderClass;
			colObj.cellClass = colConfig.columnCellClass;
			colObj.showTitle = colConfig.columnShowTitle;
			colObj.columnHasTooltip = colConfig.columnHasTooltip;
			colObj.columnTooltip = colConfig.columnTooltip;
			colObj.hasComplexProperty = colConfig.hasComplexProperty;
			colObj.complexProperty =
				colConfig.complexProperty !== undefined ? this.mapComplexPropertyToInterface(colConfig.complexProperty) : [];
			if (colConfig.columnType === 'number') {
				colObj.comparator = this.comparator.bind(this, colConfig.columnType);
			}
			datatableColumnConfiguration.push(colObj);
		}
		return datatableColumnConfiguration;
	}

	comparator(propertyName: string, a: any, b: any, c: any, d: any): number {
		if (parseFloat(c[propertyName]) < parseFloat(d[propertyName])) {
			return 1;
		}
		if (parseFloat(c[propertyName]) > parseFloat(d[propertyName])) {
			return -1;
		}
	}

	mapComplexPropertyToInterface(complexPropertyObj: any): ComplexPropertyConfiguration[] {
		const complexProperties = [];
		for (const propertyObj of complexPropertyObj) {
			const complexProperty: ComplexPropertyConfiguration = {} as ComplexPropertyConfiguration;
			complexProperty.propertyKey = propertyObj.propertyKey;
			complexProperty.propertyType = propertyObj.propertyType;
			complexProperty.propertyFormat = propertyObj.propertyFormat;
			complexProperty.cssClass = propertyObj.cssClass ? propertyObj.cssClass : `grouped-col`;
			complexProperty.styles = propertyObj.styles ? propertyObj.styles : {};
			complexProperty.prepend = propertyObj.prepend;
			complexProperty.postpend = propertyObj.postpend;
			complexProperties.push(complexProperty);
		}
		return complexProperties;
	}

	generateDatatableSourceDataFromConfig(responseObj: any, columnConfiguration: DatatableColumnConfig[]): any {
		const tempDataSourceObj: any = {};
		for (const columnConfig of columnConfiguration) {
			const formattedValue = this.valueFormatterHelper(
				responseObj[columnConfig.prop],
				columnConfig.columnType,
				columnConfig.columnFormat
			);
			tempDataSourceObj[columnConfig.prop] =
				formattedValue + (columnConfig.columnPrepend.length > 0 ? columnConfig.columnPrepend.toString() : '');

			if (columnConfig.hasComplexProperty && columnConfig.complexProperty.length > 0) {
				for (const complexProperty of columnConfig.complexProperty) {
					tempDataSourceObj[complexProperty.propertyKey] = this.valueFormatterHelper(
						responseObj[complexProperty.propertyKey],
						complexProperty.propertyType,
						complexProperty.propertyFormat
					);
				}
			}
		}
		return tempDataSourceObj;
	}

	protected valueFormatterHelper(value: any, type: string, format: string): any {
		let formattedValue = value;
		if (type === 'number') {
			const num = value !== undefined ? parseFloat(value) : '--';
			formattedValue =
				num !== 0
					? UtilityService.isFloat(num)
						? numeral(value).format('0,0.00')
						: numeral(value).format('0,0')
					: format !== undefined && format !== ''
					? numeral(num).format(format)
					: num;
		}
		if (type === 'date') {
			formattedValue = moment(value).format(format);
		}
		if (type === 'string') {
			formattedValue = value.toString();
		}
		return formattedValue;
	}
}
